import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

export function useDepartmentIsUnique(name?: string) {
  const { data, ...arg } = useQuery<{ unique: boolean }>(
    ['department-is-unique', name],
    async () => {
      const { data } = await $api.get(`/v1/department/is-unique?name=${encodeURI(name || '')}`);

      return { unique: data?.data };
    },
    {
      enabled: !!name
    }
  );

  return { ...data, ...arg };
}
